import React from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { FormattedNumber } from "react-intl";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { TextField } from "@syos-music/form";

import {
  Button,
  IconButton,
  Container,
  Stack,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Pencil as EditIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";

const QUERY = gql`
  query {
    stocks {
      id
      skuMatch
      quantity
    }
  }
`;

const MUTATION = gql`
  mutation ($stockId: ID!, $increment: Int!) {
    IncrementStock(id: $stockId, increment: $increment) {
      stock {
        id
        quantity
      }
    }
  }
`;

export default function StocksPage() {
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "network-only",
  });

  const [updateStock] = useMutation(MUTATION);

  const [stockEdit, setStockEdit] = React.useState();

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Stocks
          </Typography>
        </Stack>
      </Layout.Toolbar>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ width: "100%" }}>
                SKU
              </TableCell>
              <TableCell align="right">Quantité</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan="3" align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}

            {data?.stocks.map((stock) => (
              <TableRow
                key={stock.id}
                sx={{
                  "&:nth-of-type(odd)": {
                    bgcolor: (t) => t.palette.background.odd,
                  },
                  "&:nth-of-type(even)": {
                    bgcolor: (t) => t.palette.background.even,
                  },
                }}
              >
                <TableCell>
                  <code>{stock.skuMatch}</code>
                </TableCell>
                <TableCell align="right">
                  <FormattedNumber value={stock.quantity} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => setStockEdit(stock)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={Boolean(stockEdit)} onClose={() => setStockEdit(null)}>
        <Form
          initialValues={{ increment: 0 }}
          onSubmit={({ increment }) =>
            updateStock({ variables: { stockId: stockEdit.id, increment } })
              .then(() => {
                setStockEdit(null);
              })
              .catch(() => {})
          }
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <Dialog.Title>
                Mise à jour du stock <code>{stockEdit?.skuMatch}</code>
              </Dialog.Title>

              <Dialog.Content>
                <TextField
                  type="number"
                  step={1}
                  name="increment"
                  required
                  label="Incrément"
                />
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={() => setStockEdit(null)}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Enregistrer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </Container>
  );
}
